module.exports = {"pet":{"name":"Name","species":"Tierart","transponderId":"Transponder ID","birthdate":"Geburtsdatum","veterinarian":"Tierarzt","custody":"Obhutsperson nach meinem Ableben","addressPlaceholder":"Name, Adresse","notes":"Bemerkungen"},"addPet":{"title":"Haustier erfassen","cancelButton":"Abbrechen"},"saveButton":"Speichern","deleteButton":"Löschen","addPetAction":"Haustier erfassen +","meta":"Haustiere"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/pets.json
// module id = P0ek
// module chunks = 1